var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChangeColor = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3,2 L21,2 C22.1045695,2 23,2.8954305 23,4 L23,20 C23,21.1045695 22.1045695,22 21,22 L3,22 C1.8954305,22 1,21.1045695 1,20 L1,4 C1,2.8954305 1.8954305,2 3,2 Z",
  id: "Combined-Shape"
})));
export { SvgChangeColor as ReactComponent };
export default __webpack_public_path__ + "static/media/changeColor.0868b0e5.svg";